import { buildBundledConfig } from './build_bundled_config';

if (!globalThis.clientConfig) {
  // When running with next dev, we need to create the config since it's not injected by the server.
  // Accessing `process.env.*` here is required to inject the env vars from next cli.
  globalThis.clientConfig = buildBundledConfig(
    {
      NEXT_PUBLIC_MODE: process.env.NEXT_PUBLIC_MODE || 'production',
      VERCEL_URL: process.env.NEXT_PUBLIC_VERCEL_URL,
      NEXT_PUBLIC_WS_URL: process.env.NEXT_PUBLIC_WS_URL,
      NEXT_PUBLIC_WS_LOGGER_SOURCE: process.env.NEXT_PUBLIC_WS_LOGGER_SOURCE,
      NEXT_PUBLIC_ENABLE_AXIOS_CREDENTIALS: process.env.NEXT_PUBLIC_ENABLE_AXIOS_CREDENTIALS,
      NEXT_PUBLIC_URL: process.env.NEXT_PUBLIC_URL,
      NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
      NEXT_PUBLIC_SERVERLESS: process.env.NEXT_PUBLIC_SERVERLESS,
      NEXT_PUBLIC_WP_SUPPORT_PHONE_NUMBER: process.env.NEXT_PUBLIC_WP_SUPPORT_PHONE_NUMBER,
      NEXT_PUBLIC_WP_SUPPORT_EMAIL: process.env.NEXT_PUBLIC_WP_SUPPORT_EMAIL,
    },
    { PORT: process.env.NEXT_PUBLIC_DEV_PORT, VERSION: process.env.NEXT_PUBLIC_APP_VERSION },
  );

  // Computed configs
  globalThis.IS_DEVELOPMENT = clientConfig.NEXT_PUBLIC_MODE === 'development';
  globalThis.IS_PRODUCTION = clientConfig.NEXT_PUBLIC_MODE === 'production';
}
